import { render, staticRenderFns } from "./Points.vue?vue&type=template&id=7ca117de"
import script from "./Points.vue?vue&type=script&lang=ts"
export * from "./Points.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports